import { ErrorType } from "../enums/enums.enum";

export class ErrorModel {
	type: ErrorType;
	message: { title: string; subtitle: string };
	status: number;
	statusCode: string;
	withRetryBtn: boolean;

	constructor(init: Error | any, errorType: ErrorType) {
		this.type = errorType;

		if (init.error) {
			this.status = init.status;
			this.statusCode = init.error.status_code;
			this.message = {
				title: init.error.user_message_title ?? "Ha ocurrido un error",
				subtitle: init.error.user_message_desc ?? "No se pudo completar la operación. Por favor, intente nuevamente más tarde.",
			};
			this.withRetryBtn = false;
		} else {
			this.status = 200;
			this.statusCode = init.status_code;
			this.message = {
				title: init.user_message_title ?? "Ha ocurrido un error",
				subtitle: init.user_message_desc ?? "No se pudo completar la operación. Por favor, intente nuevamente más tarde.",
			};
			this.withRetryBtn = init.data.retry;
		}
	}

	getErrorUrl(): string {
		const encodedTitle = encodeURIComponent(this.message.title);
		const encodedMessage = encodeURIComponent(this.message.subtitle);
		return `/error?errorCode=${this.statusCode}&title=${encodedTitle}&message=${encodedMessage}&retry=${this.withRetryBtn}`;
	}

	getMessageString(): string {
		return `${this.message.title}: ${this.message.subtitle}`;
	}
}
